<template>
  <v-expansion-panel v-if="showPanel" elevation="0">
    <v-expansion-panel-title v-if="show_title">
      <v-toolbar flat color="white" density="compact" style="width:98%">
        <template v-if="$icons[relation_page.name]">
          <component v-if="$icons[relation_page.name].includes('Ph')" :is="$icons[relation_page.name]" size="24"/>
          <v-icon v-else class="mr-2" :icon="$icons[relation_page.name]"/>
        </template>
        <v-toolbar-title v-if="label">{{ $store.getters.translate(label) }}<small class="ml-1">({{ getRecords.length }})</small></v-toolbar-title>
        <v-toolbar-title v-else>{{ $store.getters.translate(relation_page.name) }}<small class="ml-1">({{ getRecords.length }})</small></v-toolbar-title>
      </v-toolbar>
    </v-expansion-panel-title>
    <v-expansion-panel-text>
      <v-toolbar flat color="white" density="compact">
        <v-spacer/>
        <div class="chip-container">
          <!--EXCEL EXPORT-->
          <base-action-button v-if="getRecords.length > 0">
            <template #prepend><PhFileXls style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
            <template #default>
              <download-excel :data="getRecordsForExport" :name="page.name + '.xls'">
                {{ $store.getters.translate('export_to_excel') }}
              </download-excel>
            </template>
          </base-action-button>
          <!--LINK-->
          <base-action-button v-if="base_table_includable_options.link && selected.length === 0 && canEditBaseModel" @action="link()">
            <template #prepend><PhLink style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
            {{ $store.getters.translate('link') }} {{ $store.getters.translate(relation_page.name) }}
          </base-action-button>
          <!--CREATE-->
          <base-action-button v-if="base_table_includable_options.create && canCreateRelatedModel" @action="$emit('create');">
            <template #prepend><PhPlus style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
            {{ $store.getters.translate("create") }}
          </base-action-button>
        </div>
        <div style="margin-right: 16px;"/>
      </v-toolbar>
      <div style="overflow-x: auto; width: 100%;">
        <v-data-table
            :headers="fields"
            :items="getRecords"
            item-value="id"
            selectable-key="id"
            return-object
            :show-select="!base_table_includable_options.no_select"
            v-model="selected"
            v-bind="footer_props"
            v-model:items-per-page="options.itemsPerPage"
            v-model:page="options.page"
            v-model:sort-by="options.sortBy"
            @update:current-items="current = $event">
          <!--CUSTOM SELECT-ALL WITH DROPDOWN-->
          <template #header.data-table-select>
            <v-chip variant="outlined" class="bulk-chip" rounded="pill" size="large" density="comfortable">
              <v-menu :disabled="selected.length === 0">
                <template #activator="{ props: menuProps, isActive }">
                  <div class="chip-content">
                    <v-checkbox
                        :model-value="selected.length > 0 && selected.length === getRecords.length"
                        :indeterminate="selected.length > 0 && selected.length < getRecords.length"
                        @click="toggleSelectAll"
                        color="success"
                        hide-details/>
                    <v-btn v-bind="menuProps" v-if="selected.length" icon class="arrow-btn" elevation="0">
                      <PhCaretUp v-if="isActive" size="20"/>
                      <phCaretDown v-else size="20"/>
                    </v-btn>
                  </div>
                </template>
                <v-list v-if="selected.length > 0 && ((base_table_includable_options.detachable && canEditBaseModel) || (base_table_includable_options.deletable && canDeleteRelatedModel))">
                  <!--DETACH-->
                  <v-list-item v-if="base_table_includable_options.detachable && canEditBaseModel" @click.stop="bulkArchiveOrDetach">
                    <template #prepend><PhLinkBreak size="24"/></template>
                    <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate("detach") }} {{ selected.length }} {{ $store.getters.translate(relation_page.name) }}</v-list-item-title>
                  </v-list-item>
                  <!--DELETE-->
                  <v-list-item v-else-if="base_table_includable_options.deletable && canDeleteRelatedModel" @click.stop="bulkArchiveOrDetach">
                    <template #prepend><PhTrash size="24"/></template>
                    <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate("delete") }} {{ selected.length }} {{ $store.getters.translate(relation_page.name) }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-chip>
          </template>
          <template #body.prepend>
            <tr>
              <td v-if="!base_table_includable_options.no_select"/><!--EMPTY TD FOR CHECKBOXES-->
              <td v-for="(key, index) in Object.keys(response_fields)" :key="index">
                <base-field-in-table-header :advanced_search="advanced_search" :field_name="key" :field_type="response_fields[key]" :page_name="relation_page.name" @showRecords="showRecords" @clearSearch="clearSearch"/>
              </td>
              <td v-if="canEditRelatedModel" style="width: 80px;"/><!--EMPTY TD FOR ACTIONS-->
            </tr>
          </template>
          <template #body="{ items }">
            <tr v-for="item in items" :key="item.id" class="sm-normal text-primary" @click.ctrl="handleCtrlClick(item)">
              <td v-if="!base_table_includable_options.no_select">
                <v-checkbox color="success" density="compact" v-model="selected" :key="item.id" :value="item" @click.shift="handleShiftClick(item)"/>
              </td>
              <td v-for="(key, index) in Object.keys(response_fields)" :key="index" @click.exact="$emit('edit', item, relation_page.name)">
                <base-field-in-table :item="item" :field_name="key" :field_type="response_fields[key]" :page_name="relation_page.name"/>
              </td>
              <!--ACTION BUTTONS-->
              <td style="text-align: center; width: 80px;" v-if="canEditRelatedModel">
                <v-menu>
                  <template #activator="{ props }">
                    <v-btn elevation="0" icon v-bind="props">
                      <PhDotsThreeVertical size="24" style="cursor: pointer;"/>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="$emit('edit', item, relation_page.name)">
                      <template #prepend><PhPencilSimpleLine size="24"/></template>
                      <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate('edit') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="relation_name === 'notes'" @click="setShowInPortal(item)">
                      <template v-if="item.visible_candidate" #prepend><PhEyeSlash size="24"/></template>
                      <template v-else-if="!item.visible_candidate" #prepend><PhEye size="24"/></template>
                      <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate('visible_candidate') }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
            <tr v-if="getRecords.length === 0">
              <td :colspan="fields.length + 1" class="text-center">
                <span class="sm-normal link">{{ $store.getters.translate("nothing_found") }}</span>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <base-link ref="base_link" :relation_page="relation_page" :excluded_ids="$lodash.map(getRecords, 'id')" @linkOrCreateRecord="linkOrCreateRecord"/>
    </v-expansion-panel-text>
  </v-expansion-panel>
</template>

<script>
import {useAbility} from '@casl/vue';
import helpFunctions from "../../plugins/helpFunctions.js";
import BaseLink from "./BaseLink";
import BaseActionButton from "./BaseActionButton";
import BaseFieldInTable from "./BaseFieldInTable";
import BaseFieldInTableHeader from "./BaseFieldInTableHeader";
import {
  PhLink,
  PhLinkBreak,
  PhPlus,
  PhCaretUp,
  PhCaretDown,
  PhDotsThreeVertical,
  PhTrash,
  PhFileXls,
  PhPencilSimpleLine,
  PhEye,
  PhEyeSlash,
} from '@phosphor-icons/vue';

export default {
  components: {
    BaseLink,
    BaseActionButton,
    BaseFieldInTable,
    BaseFieldInTableHeader,
    PhTrash,
    PhFileXls,
    PhLink,
    PhLinkBreak,
    PhPlus,
    PhCaretUp,
    PhCaretDown,
    PhDotsThreeVertical,
    PhPencilSimpleLine,
    PhEye,
    PhEyeSlash
  },
  setup() {
    const {can} = new useAbility();
    return {can}
  },
  props: ["page", "parent_module_id", "relation_name", "label", "show_title"],
  data() {
    return {
      relation_page: null,
      selected: [],
      all_records: [],
      records: [],
      companies: null,
      options: {},
      footer_props: helpFunctions.footer_props,
      base_table_includable_options: {},
      advanced_search: {
        tags_array: [],
      },
      response_fields: [],
      fields: [],
      current: [],
      export_fields: {},
    };
  },
  created() {
    this.relation_page = helpFunctions.pages[this.relation_name];
    if (helpFunctions.getLocalStorageValue(this.relation_page.name + "_includable_options")) {
      this.options = helpFunctions.getLocalStorageValue(this.relation_page.name + "_includable_options");
    } else {
      this.options = helpFunctions.table_options;
    }
    this.base_table_includable_options = helpFunctions.base_table_includable_options[this.page.name][this.relation_page.name];

    if(helpFunctions.getLocalStorageValue(this.relation_page.name + "_includable_advanced_search")) {
      this.advanced_search = helpFunctions.getLocalStorageValue(this.relation_page.name + "_includable_advanced_search");
    }

    this.getFields();
    this.getFieldsForExport();
  },
  methods: {
    toggleSelectAll() {
      const currentValues = this.current.map(item => item.value);
      const allSelected = currentValues.every(cv =>
          this.selected.some(sel => sel.id === cv.id)
      );

      if (allSelected) {
        this.selected = this.selected.filter(item =>
            !currentValues.some(cv => cv.id === item.id)
        );
      } else {
        const selectedIds = new Set(this.selected.map(item => item.id));
        const toAdd = currentValues.filter(cv => !selectedIds.has(cv.id));
        this.selected = [...this.selected, ...toAdd];
      }
    },
    async bulkArchiveOrDetach() {
      this.$confirm(this.$store.getters.translate("confirm")).then(async (res) => {
        if (res) {
          let result = {
            model_id: this.parent_module_id,
            relation_name: this.relation_page.name,
            model_to_delete: this.relation_page.model,
            ids: this.$lodash.map(this.selected, "id"),
            model: this.page.model === 'employee' && (this.relation_page.name === 'roles' || this.relation_page.name === 'tokens') ? 'User' : this.page.model,
          };
          await helpFunctions.postCustomRoute(this.$toast, "bulk/remove", result, true, true);
          this.selected = [];
          this.$emit('update');
        }
      });
    },
    async linkOrCreateRecord(objects) {
      let result = {
        model_id: this.parent_module_id,
        relation_name: this.relation_page.name,
        ids: this.$lodash.map(objects, "id"),
        objects: objects,
        model: this.page.model === 'employee' && (this.relation_page.name === 'roles' || this.relation_page.name === 'tokens') ? 'User' : this.page.model,
      };
      await helpFunctions.postCustomRoute(this.$toast, "bulk/attach", result, true, true);
      this.$emit('update');
    },
    link() {
      //SEND COMPANIES LIST TO FILTER CANDIDATES THAT WE CAN ATTACH TO CONTACT BY COMPANY. USED ON EDIT CONTACT PAGE ONLY
      this.$refs.base_link.companies = this.companies;
      this.$refs.base_link.load();
    },
    async setShowInPortal(note) {
      note.visible_candidate = !note.visible_candidate;
      await helpFunctions.saveModel(this.$toast, this.relation_name, note);
    },
    showRecords() {
      this.records = helpFunctions.showRecords(this.all_records, this.response_fields, this.advanced_search);
    },
    clearSearch(key) {
      this.advanced_search[key] = null;
      this.showRecords();
    },
    handleCtrlClick(item) {
      if (this.selected.find((el) => el.id === item.id)) {
        this.selected = this.selected.filter((el) => el.id !== item.id);
      } else {
        this.selected.push(item);
      }
    },
    handleShiftClick(item) {
      if (this.selected.length === 1 || this.selected.length === 2) {
        const IDs = [this.selected[1]?.id ?? item.id, this.selected[0].id]    // @click.shift is triggered before v-model="selected" updates, so we need to form a list of IDs from the item.
        let start = this.current.findIndex(el => el.raw.id === Math.min(...IDs));       // getting the starting element index
        let end = this.current.findIndex(el => el.raw.id === Math.max(...IDs));       //  end element index
        if (start > end) {
          let tmp = end;
          end = start;
          start = tmp;
        }
        for (let i = start; i < end; i++) {
          if (!this.selected.find((el) => el.id === this.current[i].key)) {
            this.selected.push(this.current[i].raw);
          }
        }
      }
    },
    async getFields() {
      let response = await helpFunctions.getCustomRoute(this.$toast, "fields?show_in_search=true&model_type=" + this.relation_page.model);
      this.fields = [];
      this.response_fields = [];
      response.forEach((item) => {
        this.response_fields[item.name] = item.field_type;
      });
      this.response_fields = helpFunctions.replaceIDwithNameBaseTable(this.response_fields);
      let add_actions_column = this.canEditRelatedModel;
      this.fields = helpFunctions.composeFields(this.response_fields, add_actions_column);
    },
    async getFieldsForExport() {
      let response = await helpFunctions.getCustomRoute(this.$toast, "fields?model_type=" + this.relation_page.model);
      this.export_fields = [];
      response.forEach((item) => {
        item.name = helpFunctions.replaceIDwithNameBaseTableInc(item.name);
        this.export_fields[this.$store.getters.translate(item.name)] = item.name;
      });
    },
  },
  computed: {
    getRecords() {
      if (this.records) {
        return this.records;
      } else {
        return [];
      }
    },
    getRecordsForExport() {
      return this.$lodash.cloneDeep(this.records);
    },
    canEditBaseModel() {
      return this.can("edit", this.$createEntity(this.page.model.toLowerCase(), {id: 0}));
    },
    canCreateRelatedModel() {
      return this.can("create", this.$createEntity(this.relation_page.model.toLowerCase(), {id: 0}));
    },
    canDeleteRelatedModel() {
      return this.can("delete", this.$createEntity(this.relation_page.model.toLowerCase(), {id: 0}));
    },
    canEditRelatedModel() {
      return this.can("edit", this.$createEntity(this.relation_page.model.toLowerCase(), {id: 0}));
    },
    showPanel() {
      return this.can("show", this.$createEntity(this.relation_page.model.toLowerCase(), {id: 0}));
    },
  },
  watch: {
    options: {
      handler() {
        this.selected = [];
        helpFunctions.setLocalStorageValue(this.relation_page.name + "_includable_options", this.options);
      },
      deep: true,
    },
    advanced_search: {
      handler() {
        helpFunctions.setLocalStorageValue(this.relation_page.name + "_includable_advanced_search", this.advanced_search);
        this.options.page = 1;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.v-checkbox {
  display: flex;
}

.bulk-chip {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-color: rgba(var(--v-theme-primary), 0.3);
  padding: 0px !important;
}

.chip-content {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
}

.arrow-btn {
  width: 36px;
  height: 36px;
  min-width: 0;
  background-color: transparent;
}

.chip-container {
  display: flex;
  gap: 8px;
}

.v-text-field >>> input {
  font-size: 12px !important;
}

.v-text-field >>> label {
  font-size: 12px !important;
}

/*FIX GREY BACKGROUND COLOR WHEN HOVERING OVER V-EXPANSION-PANEL-TITLE.*/
.v-expansion-panel {
  .v-expansion-panel-title:hover {
    color: transparent;
  }
}

.white-bg {
  background-color: white;
}

.lightpink-bg {
  background-color: lightpink;
}
</style>